import { Modal } from "antd";
import { useEffect, useState } from "react";
import { useFormik } from "formik";
import * as yup from "yup";
import { handlePayment } from "../apis/callingAPis";
import Cookies from "js-cookie";
import { useAuth } from "../context/authContext";

const LogModal = ({
  islogModalOpen,
  showlogModal,
  showcardPaymentModal,
  agentId,
}) => {
  const [loading, setLoading] = useState(false);
  const { setAuthData } = useAuth();

  const validationSchema = yup.object({
    name: yup.string().required("Name is required"),
    email: yup
      .string()
      .email("Invalid email format")
      .required("Email is required"),
  });

  const formik = useFormik({
    initialValues: {
      name: "",
      email: "",
    },
    validationSchema,
    onSubmit: async (values) => {
      setLoading(true);

      Cookies.set("userEmail", values.email);
      Cookies.set("userName", values.name);
      Cookies.set("agentId", agentId);
      console.log("agentIdagentIdagentIdagentId", agentId);
      try {
        const { client_secret, customer_id } = await handlePayment(
          values.email,
          values.name,
          agentId
        );
        setAuthData({
          username: values?.name,
          agenid: agentId,
          email: values.email,
          customerId: customer_id,
          clientSecret: client_secret,
        });
        showcardPaymentModal();
        formik.resetForm();
      } catch (err) {
        console.error(err || "An unexpected error occurred");
        formik.resetForm();
      } finally {
        setLoading(false);
      }
    },
  });

  return (
    <>
      <Modal
        open={islogModalOpen}
        onCancel={showlogModal}
        centered
        footer={null}
        className="white-log-modal "
      >
        <form onSubmit={formik.handleSubmit} className="log-form">
          <div className="input-wrap">
            <label>Name</label>
            <div className="input-div">
              <input
                type="text"
                placeholder="Enter your Name"
                name="name"
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                value={formik.values.name}
              />
            </div>
            {formik.touched.name && formik.errors.name && (
              <div className="text-red ">{formik.errors.name}</div>
            )}
          </div>
          <div className="input-wrap">
            <label>Email</label>
            <div className="input-div">
              <input
                type="email"
                placeholder="Enter your Email"
                name="email"
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                value={formik.values.email}
              />
            </div>
            {formik.touched.email && formik.errors.email && (
              <div className="text-red">{formik.errors.email}</div>
            )}
          </div>
          <button
            className="cursor-pointer btn-primary"
            disabled={loading}
            type="submit"
          >
            {loading ? "Loading..." : "Continue"}
          </button>
        </form>
      </Modal>
    </>
  );
};

export default LogModal;
